import styled from 'styled-components';
import cores from '../../styles/cores';

export const ModalContainerEditCommission = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 16px;

  .field-group {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-width: 100%;
    padding: 0px;
    margin-top: 24px;
    
    .date-input {
      margin-top: 24px;
      width: 220px;
    }
  }
`;

export const BotaoContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 32px;
  width: 100%;

  .btn {
    width: fit-content;
  }
`;